import React from 'react';
import { withTranslation } from 'react-i18next';
// material ui
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import 'moment/locale/ar'
// components
import theme from '../../config/theme'
import '../../assets/stylesheet/addcompany.css';

const titleTheme = createTheme(adaptV4Theme({
    overrides: {
    MuiTypography: {
      body1: {
        fontSize:'0.6rem !important', 
        fontFamily:'inherit !important'
      },
    },

    MuiDialogTitle:{
        root:{
            padding: '0px !important'
        }
    },

    MuiFormGroup:{
        root:{
            flexWrap:'nowrap !important'
        },
        row:{
            flexWrap:'nowrap !important'
        }
    }
    }
}))

const useStyles = makeStyles((theme) => ({

    headerMainDiv:{
        display:'flex',
        flexDirection:'column',
        width:'65%',
        justifyContent:'space-between',
        alignSelf:'flex-end',
        alignItems:'center',
    },

    nonEditBtn:{
        width:'100%',
        justifyContent: 'center',
        alignSelf:'center'
    },

    mainTitle:{
        fontWeight:'bold',
        color:'#122C6E',
        fontSize:"18px",
        textTransform:'uppercase',
        alignSelf:'center',
        [theme.breakpoints.between('xs','md')]:{
            fontSize:'14px'
        },
    },

    paperRoot:{
        padding:'20px 0px 10px 0px',
        borderRadius:'10px',
        [theme.breakpoints.down('md')]:{
            width:'calc(100% - 16px)',
            margin:'32px 8px'
        }
    },

    dialogRoot:{
        '& .MuiBackdrop-root':{
            backgroundColor:'#F0F2F5',
            opacity:'0.5 !important'
        }
    }
}))

function CustomDialog(props) {
    const componentRef = React.useRef(null);
    let {  children, children2, title, i18n, lang, dispatch, maxWidth, tReady,customClasses,contentCustomCls, actionCustomCls, dialogRootCustomCls, ...other } = props;
    moment.locale(lang);
    const classes = useStyles();
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;

    const handleClose = () => {
        props.onClose();
    };
    

    return (
        <>
        <Dialog
              {...other}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
              style={{fontFamily}}
              fullWidth={true}
              disableEnforceFocus
              maxWidth={maxWidth ? maxWidth : 'sm'}
              ref={componentRef}
              classes={{paper:classes.paperRoot,root:`${classes.dialogRoot} ${dialogRootCustomCls || ''}`,...customClasses}}
            >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <div className={`${classes.headerMainDiv} ${classes.nonEditBtn}`}>
                        <StyledEngineProvider injectFirst>
                            <ThemeProvider theme={titleTheme}>
                                <DialogTitle id="alert-dialog-title"><span className={classes.mainTitle} style={{fontFamily}}>{title}</span></DialogTitle>
                            </ThemeProvider>
                        </StyledEngineProvider>
                    </div>
                </ThemeProvider>
            </StyledEngineProvider>
            <DialogContent className={contentCustomCls} style={{display:'flex',flexDirection:'column',position:'relative'}}>
                {children}
            </DialogContent>
            <DialogActions className={actionCustomCls}>
                {children2}
            </DialogActions>
        </Dialog>
        </>
    )
};

export default withTranslation('common')(CustomDialog);